<template>
  <div>
    <div class="index-logo" @click="toggleSideBar">
      <img class="index-logo-img" src="/static/image/logo-tran.png" alt="">
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :show-timeout="200" :unique-opened="true" :default-active="$route.path" :collapse="isCollapse" mode="vertical" background-color="#304156" text-color="#bfcbd9" active-text-color="#15bd8a">
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.el-scrollbar {
  height: calc(100% - 80px);
}
.index-logo {
  width: 220px;
  height: 80px;
  box-sizing: border-box;
  background: #1f2d3d;
  padding-left: 20px;
  padding-top: 16px;
}
img.index-logo-img {
  display: block;
  height: 45px;
}

.hideSidebar .index-logo {
  padding: 0;
  height: 40px;
  padding-top: 8px;
}

.hideSidebar .index-logo img.index-logo-img {
  height: 21px;
}

.hideSidebar .el-scrollbar {
  height: calc(100% - 40px);
}
</style>